import React, { useState, useEffect } from "react";
import { Offline } from "react-detect-offline";
import { InternetIssueModeModal } from "../../utils/modal";

const OfflineDetector = () => {
  const [isOffline, setIsOffline] = useState(false);

  const closeModal = () => {
    setIsOffline(false);
  };

  useEffect(() => {
    const handleOfflineStatus = () => {
      setIsOffline(!navigator.onLine);
    };
    window.addEventListener("online", handleOfflineStatus);
    window.addEventListener("offline", handleOfflineStatus);

    return () => {
      window.removeEventListener("online", handleOfflineStatus);
      window.removeEventListener("offline", handleOfflineStatus);
    };
  }, []);

  return (
    <Offline>
      <InternetIssueModeModal isActive={isOffline} onClose={closeModal} />
    </Offline>
  );
};

export default OfflineDetector;
